import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HeadWrapper from 'app/shared/components/HeadWrapper';
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';
import Select from '@zillow/constellation/lib/components/Select/Select';
import { Container } from '@zillow/zrs-comet';
import Row from '@zillow/zrs-comet/lib/components/Row/Row';
import Col from '@zillow/zrs-comet/lib/components/Col/Col';
import Label from '@zillow/constellation/lib/components/Label/Label';
import LoadingMask from '@zillow/constellation/lib/components/LoadingMask/LoadingMask';
import AnalyticsActions from '../../../actions/AnalyticsActions';

const DEFAULT_PAGE_TITLE = 'Market';

const MarketPage = () => {
    const DEFAULT_PROPERTY_VALUE = 'defaultProperty';
    const DEFAULT_UNIT_VALUE = 'defaultUnit';

    const [isLoadingProperties, setIsLoadingProperties] = useState(true);
    const [selectedListingAlias, setSelectedListingAlias] = useState(DEFAULT_PROPERTY_VALUE);
    const [isMultifamilySelected, setIsMultifamilySelected] = useState(false);
    const [isLoadingUnits, setIsLoadingUnits] = useState(false);
    const [selectedUnitId, setSelectedUnitId] = useState(DEFAULT_UNIT_VALUE);

    const marketPropertiesSelect = useSelector(state => state.analytics.marketPropertiesSelect);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(AnalyticsActions.getMarketPropertiesSelect())
            .then(() => setIsLoadingProperties(false))
            .catch(() => setIsLoadingProperties(false));
    }, []);

    const handlePropertySelect = (event) => {
        const listingAlias = event.target.value;
        setSelectedListingAlias(listingAlias);
        setSelectedUnitId(DEFAULT_UNIT_VALUE);
        const selectedProperty = marketPropertiesSelect.propertiesByAlias[listingAlias];
        if (selectedProperty.isMultifamily) {
            setIsMultifamilySelected(true);
            setIsLoadingUnits(true);
            dispatch(AnalyticsActions.getMarketUnitsForProperty(listingAlias))
                .then(() => setIsLoadingUnits(false))
                .catch(() => setIsLoadingUnits(false));
        }
    };

    const handleUnitSelect = (event) => {
        setSelectedUnitId(event.target.value);
    };

    const renderSelectedUnit = () => 'Selected Address: '
            + `${marketPropertiesSelect.propertiesByAlias[selectedListingAlias].address} - ${selectedUnitId}`;

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <div>
                <HeadWrapper title={DEFAULT_PAGE_TITLE} />
                <Container
                    marginTop="lg"
                    marginBottom="lg"
                >
                    <Row>
                        <Col md={12} lg={5} xl={5}>
                            <LoadingMask loading={isLoadingProperties}>
                                <Label>Property</Label>
                                <Select
                                    name="propertySelect"
                                    value={selectedListingAlias}
                                    disabled={isLoadingProperties}
                                    onChange={handlePropertySelect}
                                >
                                    <option disabled={true} value={DEFAULT_PROPERTY_VALUE}>Choose a property</option>
                                    {marketPropertiesSelect.properties.map(property => (
                                        <option key={property.listingAlias} value={property.listingAlias}>
                                            {property.name}
                                        </option>
                                    ))}
                                </Select>
                            </LoadingMask>
                        </Col>
                    </Row>
                    {isMultifamilySelected && (
                        <Container
                            marginTop="lg"
                            marginBottom="lg"
                        >
                            <Row>
                                <Col md={12} lg={5} xl={5}>
                                    <LoadingMask loading={isLoadingUnits}>
                                        <Label>Unit</Label>
                                        <Select
                                            name="unitSelect"
                                            value={selectedUnitId}
                                            disabled={isLoadingUnits}
                                            onChange={handleUnitSelect}
                                        >
                                            <option disabled={true} value={DEFAULT_UNIT_VALUE}>Choose a unit</option>
                                            {Object.entries(marketPropertiesSelect.unitsByFloorplanName)
                                                .map(([floorPlanName, units]) => (
                                                    <optgroup key={floorPlanName} label={floorPlanName}>
                                                        {units.map(unit => (
                                                            <option
                                                                key={unit.unitId}
                                                                value={unit.unitName}
                                                            >
                                                                {unit.unitName}
                                                            </option>
                                                        ))}
                                                    </optgroup>
                                                ))}
                                        </Select>
                                    </LoadingMask>
                                </Col>
                            </Row>
                        </Container>
                    )}
                </Container>
                {selectedUnitId !== DEFAULT_UNIT_VALUE && (
                    <>
                        <hr />
                        <Container marginBottom="lg">
                            {renderSelectedUnit()}
                        </Container>
                    </>
                )}
            </div>
        </AuthCheckWrapper>
    );
};


export default MarketPage;
